import React, { Fragment } from 'react';
import moment from 'moment';

const DateOutput = ({ value, format = 'DD/MM/YYYY' }) => (
  <Fragment>{value != null ? moment(value).format(format) : ''}</Fragment>
);

export default DateOutput;
